module.exports = __webpack_public_path__ + "img/29.41c6aef3.png";